import { useQuery } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { SortDirection } from '../components/table/sortable-header';

type DirectReportData = {
	activeGoalCount?: number | null;
	deletedAt: string | false | null;
	displayName: string;
	lastCheckInDate: string;
	lastCheckInScore: number;
	oneOnOneUpdated?: boolean | null;
	profilePicUrl: string;
	recognitionManagerCount: number;
	totalRecognitionCount?: number | null;
	upcomingOneOnOneDate?: string | null;
	userId: string;
	username: string;
};

type DirectReportsOverviewResponse = DirectReportData[];

type Params = {
	sortBy?: string | null;
	sortDirection?: SortDirection | null;
	enabled?: boolean;
};

type SortParams = {
	sort_by?: string;
	sort_direction?: SortDirection;
};

const buildSortParams = (sortBy?: string | null, sortDirection?: SortDirection | null): SortParams => {
	const normalizedSortBy = sortBy?.trim();

	if (!normalizedSortBy) {
		return {};
	}

	const normalizedSortDirection = sortDirection === SortDirection.ASC || sortDirection === SortDirection.DESC ? sortDirection : SortDirection.ASC;

	return {
		sort_by: normalizedSortBy,
		sort_direction: normalizedSortDirection,
	};
};

const directReportsOverviewQueryKey = (sortParams: SortParams) => ['direct-reports-overview', sortParams.sort_by ?? null, sortParams.sort_direction ?? null];

export const useDirectReportsOverview = (params: Params) => {
	const http = useHttpClient();
	const sortParams = buildSortParams(params.sortBy, params.sortDirection);
	return useQuery(
		directReportsOverviewQueryKey(sortParams),
		async () => {
			const res = await http.get<DirectReportsOverviewResponse>('/analytics/team/direct_team/direct_reports_overview', {
				headers: {
					'Key-Inflection': 'camel',
				},
				params: sortParams,
			});

			return res.data;
		},
		{
			retry: false,
			refetchOnWindowFocus: false,
			enabled: params.enabled,
		}
	);
};
